import { AuthGraphQLProvider, AuthProvider } from '@codezo/auth';
import App from './App';
import { useAuth } from './hooks/useAuth';

export default function Inialize() {
	const InializeApp = () => {
		const { token } = useAuth();

		return (
			<AuthGraphQLProvider
				token={token || ''}
				uri={import.meta.env.VITE_GRAPHQL_ENDPOINT}
				audience="admin"
			>
				<App />
			</AuthGraphQLProvider>
		);
	};

	return (
		<AuthProvider>
			<InializeApp />
		</AuthProvider>
	);
}
